import {
  React,
  Component,
  axios,
  routes,
  helpers,
} from 'imports/CommonImports';

import {
  Paper,
  TextField,
} from 'material-ui';

import {
  PrimaryButton,
} from 'imports/DesignImports';

const styles = {
  paper: {
    padding: '1em'
  },
  header: {
    marginLeft: '1em'
  },
  fieldsContainer: {
    display: 'flex',
    paddingRight: '15px'
  },
  fieldContainer: {
    minWidth: '25%',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    margin: '0px 15px',
    fontWeight: '300',
  },
  field:{
    fontFamily: 'Lato',
    fontStyle: 'italic',
    paddingLeft: '10px',
    paddingRight: '0',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1em',
  },
}

class CreateConsultant extends Component {
  constructor(props){
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      token: props.cookies.get('token'),
      emailError: '',
    }
  }
  render() {
    return (
      <div>
        <Paper zDepth={1} style={styles.paper}>
          <h3 style={styles.header}>Datos del consultor</h3>
            <div style={styles.fieldsContainer}>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Nombre</div>
                <TextField
                inputStyle={styles.field}
                name="firstName"
                value={this.state.firstName}
                onChange={this.handleChange}
                />
                </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Apellidos</div>
                <TextField
                inputStyle={styles.field}
                name="lastName"
                value={this.state.lastName}
                onChange={this.handleChange}
                />
              </div>
              <div style={styles.fieldContainer}>
                <div style={styles.label}>Mail</div>
                <TextField
                inputStyle={styles.field}
                name="email"
                errorText={this.state.emailError}
                value={this.state.email}
                onChange={this.handleChange}
                />
              </div>
          </div>
        </Paper>
        <div style={styles.buttonContainer}>
          <PrimaryButton label='Enviar Datos' onClick={this.createConsultant} />
        </div>
      </div>
    );
  }

  handleChange = (event) => {
    var key = event.target.name;
    var value = event.target.value;
    if(key === 'email')
      !helpers.validEmail(event.target.value.toLowerCase()) ? this.setState({emailError: 'Debes ingresar un email válido'}) : this.setState({emailError: ''})
    this.setState({[key]: value});
  }

  createConsultant = () => {
    this.props.raiseLoading();
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });

    var data = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
    }

    for (var key in data) {
       if (data.hasOwnProperty(key) && (data[key] === '' || data[key] === 0 || this.state.emailError !== '')) {
         this.props.raiseAlertOneButton('¡Error!', 'Todos los campos deben ser llenados apropiadamente')
         return;
       }
    }

    connection.post(routes.innspiralStaff, data)
    .then((response) => {
      this.props.raiseAlertOneButton('¡Éxito!', 'El nuevo consultor se ha creado sin problemas')
      this.setState({
        firstName: '',
        lastName: '',
        email: '',
      })
    })
    .catch((err) => {
      this.props.raiseAlertOneButton('¡Error!', 'Hubo un problema al crear el consultor, intenta nuevamente')
    })
  }
}

export default CreateConsultant;



// WEBPACK FOOTER //
// ./src/components/administration/CreateConsultant.js